module.exports = __webpack_public_path__ + "img/residential-parkland-icon.e059b711.svg";